<template lang="pug">
  #ResellersTable
    .level
      .level-left
        .level-item
          WtTitle(h2) Resellers
      .level-right
        .level-item
          WtButton(
            color="primary"
            @click.native="addModalOpen = true"
          )
            | + New Reseller

    BModal(has-modal-card :active.sync="addModalOpen")
      AddResellerModal(@added="onResellerAdded" @close="addModalOpen = false")

    BModal(has-modal-card :active.sync="deleteModalOpen")
      DeleteResellerConfirmDialog(
        :reseller="selectedReseller"
        :loading="deleting"
        @confirm="onDeleteConfirm"
        @close="deleteModalOpen = false"
      )

    BTable(
      :data="resellers"
      :paginated="pagination && pagination.total > pagination.perPage"
      :backend-pagination="true"
      :total="pagination ? pagination.total : 0"
      :per-page="pagination ? pagination.perPage : 20"
      :current-page="pagination ? pagination.current_page : 1"
      @page-change="onPageChange"
      :loading="loading"
      :striped="true"
      default-sort-direction="asc"
      default-sort="name"
    )
      BTableColumn(field="name" label="Reseller Name" v-slot="props")
        | {{ props.row.name }}

      BTableColumn(field="programCount" label="Program Count" centered v-slot="props")
        | {{ props.row.programCount }}

      BTableColumn(field="masterProgramUrl" label="Main Program" centered v-slot="props")
        | {{ props.row.masterProgramUrl }}

      BTableColumn(field="login" label="Login" centered v-slot="props")
        a(:href="props.row.ssoLoginUrl" target="_blank" title="Will open in new tab" class="ssoLink")
          | Login into Reseller

      BTableColumn(label="" v-slot="props")
        .is-flex.is-justify-content-flex-end
          span.delete-icon(
            @click="confirmDelete(props.row)"
            title="Delete"
            style="cursor: pointer;"
          )
            WtSvgIcon(icon="delete")

      template(#empty v-if="!loading")
        .content.has-text-centered
          p No Resellers.
</template>

<script>
import { mapActions } from "vuex";
import WtTitle from "@@/WtTitle/WtTitle.vue";
import WtButton from "@@/WtButton/WtButton.vue";
import WtSvgIcon from "@@/WtSvgIcon/WtSvgIcon.vue";
import AddResellerModal from "./AddResellerModal.vue";
import DeleteResellerConfirmDialog from "./DeleteResellerConfirmDialog.vue";

export default {
  name: "ResellersTable",

  components: {
    WtTitle,
    WtButton,
    WtSvgIcon,
    AddResellerModal,
    DeleteResellerConfirmDialog
  },

  data() {
    return {
      resellers: [],
      pagination: null,
      loading: false,
      addModalOpen: false,
      deleteModalOpen: false,
      selectedReseller: null,
      deleting: false
    };
  },

  async mounted() {
    await this.fetchResellers();
  },

  methods: {
    ...mapActions(["snackBar"]),

    async fetchResellers(page = 1) {
      this.loading = true;
      try {
        const { data } = await this.axios.get(
          "super/reseller/getAllResellers",
          {
            params: { page }
          }
        );
        this.resellers = data.data.items || [];
        this.pagination = {
          total: data.data.totalRows,
          perPage: 20,
          current_page: page
        };
      } catch (error) {
        console.error("Error fetching resellers:", error);
        this.snackBar({
          duration: 5000,
          type: "is-danger",
          message: "Failed to load resellers."
        });
      } finally {
        this.loading = false;
      }
    },

    async onPageChange(page) {
      await this.fetchResellers(page);
    },

    confirmDelete(reseller) {
      this.selectedReseller = reseller;
      this.deleteModalOpen = true;
    },

    async onDeleteConfirm(reseller) {
      this.deleting = true;
      try {
        await this.axios.delete(`super/reseller/${reseller.id}`);
        this.resellers = this.resellers.filter(r => r.id !== reseller.id);
        this.deleteModalOpen = false;
        this.snackBar({
          message: "Reseller deleted.",
          type: "is-success"
        });
      } catch (error) {
        console.error("Error deleting reseller:", error);
        this.snackBar({
          message: "Failed to delete reseller.",
          type: "is-danger"
        });
      } finally {
        this.deleting = false;
      }
    },

    async onResellerAdded() {
      this.addModalOpen = false;
      this.snackBar({
        message: "Reseller added.",
        type: "is-success"
      });
      await this.fetchResellers();
    }
  }
};
</script>

<style lang="sass" scoped>
a.ssoLink
  color: #2285ff

.delete-icon
  visibility: hidden

::v-deep tr:hover .delete-icon
  visibility: visible
</style>
